<template>
  <div class="event-container" >
    <div class="container" v-if="this.properties&&this.eventTypes">
        <div class="page-header d-flex justify-content-between align-items-center" style="z-index: 990;">
          <h4 class="text-white m-0">Add Event</h4>
          <div class="d-flex">
            <div>
              <b-button v-b-toggle.vendors-button class="mr-2" variant="outline-light" href="#" tabindex="0" @click="loadPropertyVendors" :disabled="selectedPropertyId ? false : true">
                <i class="fas fa-user"></i>
              </b-button>
              <b-collapse id="vendors-button" title="Vendors" triggers="click blur" class="side-panel right">
                <div v-if="propertyVendors" class="d-flex flex-column h-100">
                  <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
                    <h5 class="m-0">Vendors</h5>
                    <b-button v-b-toggle.vendors-button variant="link" href="#" tabindex="0" @click="loadPropertyVendors" :disabled="selectedPropertyId ? false : true">
                      <i class="fas fa-times text-dark"></i>
                    </b-button>
                  </div>
                  <div class="flex-grow-1 overflow-auto ">
                    <div class="list-group list-group-flush">
                      <div class="list-group-item d-flex align-items-center p-3" v-for="vendor in propertyVendors" v-bind:key="vendor.name">
                        <div class="row no-gutters w-100 align-items-center">
                          <div class="col-8">
                            <h6 class="m-0"><strong>{{vendor.name}}</strong></h6>
                          </div>
                          <div class="col-4 text-right">
                            <a :href='"mailTo:" + vendor.email'><b-button size="sm"><i class="fas fa-envelope"></i></b-button></a>
                            <a :href='"tel:" + vendor.phone'><b-button size="sm"><i class="fas fa-phone"></i></b-button></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
            <div>
              <b-button v-b-toggle.contacts-button variant="outline-light" class="mr-4" href="#" tabindex="0" @click="loadContacts" :disabled="selectedPropertyId ? false : true">
                <i class="fas fa-phone"></i>
              </b-button>
              <b-collapse id="contacts-button" title="Points of Contact" triggers="click blur" class="side-panel right">
                <div v-if="propertyContacts" class="d-flex flex-column h-100">
                  <div class="d-flex justify-content-between align-items-center p-3 border-bottom">
                    <h5 class="m-0">Points of Contact</h5>
                    <b-button v-b-toggle.contacts-button variant="link" href="#" tabindex="0" @click="loadContacts" :disabled="selectedPropertyId ? false : true">
                      <i class="fas fa-times text-dark"></i>
                    </b-button>
                  </div>
                  <div class="flex-grow-1 overflow-auto">
                    <div class="list-group list-group-flush">
                      <div class="list-group-item d-flex align-items-center p-3" v-for="contact in propertyContacts" v-bind:key="contact.name">
                        <div class="row no-gutters w-100 align-items-center">
                          <div class="col-8">
                            <h6 class="m-0"><strong>{{contact.name}}</strong></h6>
                          </div>
                          <div class="col-4 text-right">
                            <a :href='"mailTo:" + contact.email'><b-button size="sm"><i class="fas fa-envelope"></i></b-button></a>
                            <a :href='"tel:" + contact.phone'><b-button size="sm"><i class="fas fa-phone"></i></b-button></a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
            <router-link to="/" class="btn btn-light">Cancel</router-link>
          </div>
        </div>
        <form-wizard :validate-on-back="true" ref="wizard" color="#20a0ff">
          <!--Location-->
          <tab-content title="Event Info" :before-change="validateFirstTab" icon="icon check">
            <h4 class="text-white">Event Information</h4>
            <b-form class="pt-md-3 pt-5">
              <b-form-group class="d-block">
                <label class="control-label">Property</label>
                <b-form-select class="field w-100 m-0" :options="propertyOptions" v-model="selectedPropertyId" name="Property">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Property</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="validation" v-if="this.eventErrors.propertyRequiredInError"> Property is required. </div>
              </b-form-group>
              <div class="mt-n2 mb-3 d-md-block d-none" v-if='currentEvent.property.address'>
                <div class="card bg-light px-3 py-2 rounded">
                  <p class="text-black mb-0">
                    <small>Address: {{currentEvent.property.address.streetAddress1}}, {{currentEvent.property.address.city}}, {{currentEvent.property.address.state}}</small><br/>
                  </p>
                </div>
              </div>
              <b-form-group class="d-block">
                <label class="control-label">Location</label>
                <input class="form-control" rows="2" v-model="eventForEdit.location">
              </b-form-group>
              <b-form-group class="mt-3 d-block">
                <label class="control-label">Response Type</label>
                <b-form-select class="expanded-dropdown w-100" :options="eventTypeOptions" v-model="selectedTypeId">
                  <template #first>
                  <b-form-select-option :value="null" disabled>Type</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="validation" v-if="this.eventErrors.typeRequiredInError"> Type is required. </div>
              </b-form-group>
              <b-form-group class="d-block">
                <label class="control-label">Category</label>
                <b-form-select class="w-100" :options="eventCategoryOptions" v-model="selectedCategoryId">
                  <template #first>
                  <b-form-select-option :value="null" disabled>Category</b-form-select-option>
                  </template>
                </b-form-select>
                <div class="validation" v-if="this.eventErrors.categoryRequiredInError"> Category is required. </div>
              </b-form-group>
            </b-form>
          </tab-content>

          <!--Type-->
          <tab-content title="Emergency" icon="icon check" class="h-100">
            <div class="d-flex flex-column flex-grow-1 justify-content-stretch h-100">
              <div class="card border-0 bg-danger mt-md-3 mt-5 p-3 d-flex flex-row align-items-center justify-content-between">
                <div>
                  <h5 class="mb-0 text-white">Emergency Services</h5>
                  <p class="mb-0 text-white">If Police, Fire or EMS are needed, STOP and</p>
                </div>
                <a class="btn btn-outline-light" href="tel:911"><strong>CALL 911</strong></a>
              </div>
              <b-card class="fluid flex-grow-1 align-items-center justify-content-center mb-2 shadow-none border-0" no-body>
                <b-card-text class="d-block flex-grow-0 text-center">
                    <h5 class="mb-3">Are any emergency services involved?</h5>
                    <b-button size="lg" variant="outline-danger" :pressed="!emergencyServicesInvolved&&eventForEdit.emergencyServicesInvolvedAnswered" @click="emergencyServicesInvolved=false;goNext()">No</b-button>
                    <b-button size="lg" variant="outline-success"  :pressed="emergencyServicesInvolved&&eventForEdit.emergencyServicesInvolvedAnswered" @click="emergencyServicesInvolved=true;goNext()">Yes</b-button>
                  <div class="validation" v-if="this.eventErrors.emergencyServicesInvolvedInError"> You must answer whether emergency services are involved. </div>
                </b-card-text>
              </b-card>
            </div>
          </tab-content>

          <!--Severity/Date-->
          <tab-content title="Review" icon="icon check" :before-change="validateSeverityAndDateStep" class="h-100">
            <div class="row flex-column flex-grow-1 justify-content-stretch align-items-center h-100">
              <div class="col-lg-8 col-md-10 col-12 h-100 flex-grow-1">
                <b-form class="d-flex flex-column justify-content-center h-100">
                  <b-form-group class="mb-5">
                    <label class="w-100 control-label">Event Severity</label>
                    <div class="d-flex flex-nowrap">
                      <b-button size="lg" variant="outline-success" :pressed='this.selectedEventSeverity === 0' @click="selectedEventSeverity = 0"><i class="fas fa-arrow-down"></i> Low</b-button>
                      <b-button size="lg" variant="outline-danger" :pressed='this.selectedEventSeverity === 1' @click="selectedEventSeverity = 1"><i class="fas fa-arrow-up"></i> High</b-button>
                    </div>
                  </b-form-group>
                  <div class="row">
                    <div class="col-12">
                      <b-form-group>
                        <label class="control-label">Responders Name</label>
                        <input class="form-control form-control-lg" type="text" name="last-name" placeholder="Name" v-model="eventForEdit.reportedByName">
                      </b-form-group>
                    </div>
                    <div class="col-12">
                      <b-form-group>
                        <label class="control-label">Time & Date</label>
                        <datetime v-model="selectedDateTime" type="datetime" placeholder="Select Date/Time"></datetime>
                        <div class="validation" v-if="this.eventErrors.dateTimeRequiredInError"> Date and Time are required. </div>
                      </b-form-group>
                    </div>
                  </div>
                </b-form>
              </div>
            </div>
          </tab-content>

          <!--Questions-->
          <tab-content title="Procedure" :before-change="beforeTabChange" icon="icon check" class="h-100">
            <div class="d-flex flex-column flex-grow-1 justify-content-stretch h-100">
              <b-card class="fluid flex-grow-1 align-items-center justify-content-center mb-2 mt-4 shadow-none border-0" no-body>
                <b-card-text class="d-block flex-grow-0 text-center w-100">
                  <h5 class="mb-3">{{ this.currentQuestion.text == 'Images' ? 'Images/Video ' : this.currentQuestion.text }}</h5>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'YesOrNo'">
                    <div>
                      <b-button size="lg" variant="outline-danger" :pressed="!this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=false;goNext()">No</b-button>
                      <b-button size="lg" variant="outline-success" :pressed="this.currentAnswer && this.currentQuestion.answered" @click="currentAnswer=true;goNext()">Yes</b-button>
                    </div>
                  </div>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'TextInput'">
                    <div class="row justify-content-center">
                      <div class="col-lg-8 col-md-10 col-12">
                        <b-form-textarea class="form-control" style="resize: none;" rows="4" v-model="currentQuestion.textAnswer"></b-form-textarea>
                      </div>
                    </div>
                  </div>
                  <div v-show="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Acknowledgement'">
                    <div>
                      <b-button size="lg" variant="outline-primary" :pressed="currentQuestion.answer" @click="currentQuestion.answer=!currentQuestion.answer;goNext()">Acknowledge</b-button>
                    </div>
                  </div>
                  <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'Checklist'">
                    <div class="row justify-content-md-center">
                      <div class="col-lg-8 col-md-10 col-12 text-left">
                        <div class="list-group">
                           <b-form-checkbox class="list-group-item checkbox-list" v-for="checklistItem in this.currentQuestion.checklistItems" v-bind:key="checklistItem.text" v-model="checklistItem.checked">{{checklistItem.text}}</b-form-checkbox>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'ImageUpload'">
                    <div class="row flex-column flex-grow-1 justify-content-stretch align-items-center h-100">
                      <div class="col-xl-8 col-lg-10 col-md-10 col-12">
                        <ValidationObserver v-slot="{ invalid }" ref="imageFormValidationObserver">
                        <b-form enctype="multipart/form-data" ref="fileForm" class="d-flex flex-column justify-content-center mt-5">
                          <div class="form-group mb-1">
                              <h5 class="mb-2">Upload Images/Video &nbsp;<span v-if="processing"><b-spinner class="small mb-1" small label="Small Spinner"></b-spinner></span></h5>
                              <b-input-group>
                                <b-form-file
                                    multiple
                                    v-model="mediasForUpload.files"
                                    :state="Boolean(mediasForUpload.files.length)"
                                    placeholder="Choose images/videos or drop them here..."
                                    drop-placeholder="Drop image(s)/video(s) here..."
                                    :accept="acceptedFileExtensionsWithDot"
                                    class="multi-file"
                                  ></b-form-file>
                              </b-input-group>
                          </div>
                          <div class="d-flex justify-content-end">
                            <b-button variant="primary" type="button" :disabled="!readyForUpload(invalid)" @click="uploadMediasForEventQuestion(currentQuestion.id)">Upload</b-button>
                          </div>
                        </b-form>
                        </ValidationObserver>
                        <label class="mt-3 mb-1"><strong>Images</strong></label>
                        <b-list-group class="card bg-light rounded p-1 img-list">
                          <b-list-group-item v-for="image in currentQuestionImages" v-bind:key="image.id" class="d-flex align-items-center">
                            <FileThumbnail :thumbnail-url="image.thumbnailMicroPublicUrl || image.thumbnailPublicUrl" :full-url="image.publicUrl" file-type="image" size="micro" style="width:50px;height:50px;object-fit:cover;" />
                            <div class="text-dark">
                              <a class="pl-3 text-dark">{{ image.name }}</a>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </div>
                  </div>
                  <div v-if="spr2_lookupTypeId(this.currentQuestion.typeId) === 'ImageUpload'">
                    <div class="row flex-column flex-grow-1 justify-content-stretch align-items-center h-100">
                      <div class="col-xl-8 col-lg-10 col-md-10 col-12">
                        <label class="mt-3 mb-1"><strong>Videos</strong></label>
                        <b-list-group class="card bg-light rounded p-1 video-list">
                          <b-list-group-item v-for="video in currentQuestionVideos" v-bind:key="video.id" class="d-flex align-items-center">
                            <FileThumbnail size="micro" file-type="video" :thumbnail-url="video.thumbnailPublicUrl" :full-url="video.publicUrl" :processing-status="video.videoProcessingStatus" style="width:50px;height:50px;" />
                            <div class="text-dark">
                              <a class="pl-3 text-dark">{{ video.name }}</a>
                            </div>
                          </b-list-group-item>
                        </b-list-group>
                      </div>
                    </div>
                  </div>
                  <div class="validation" v-show="this.eventErrors.procedureStepInError">{{this.eventErrors.procedureStepInErrorText}}</div>
                </b-card-text>
              </b-card>
            </div>
          </tab-content>

          <!--Media-->
          <tab-content title="Images/Videos" icon="icon check" class="h-100">
            <div class="row flex-column flex-grow-1 justify-content-stretch align-items-center">
              <div class="col-xl-8 col-lg-10 col-md-10 col-12">
                <ValidationObserver v-slot="{ invalid }" ref="imageFormValidationObserver">
                <b-form enctype="multipart/form-data" ref="fileForm" class="d-flex flex-column justify-content-center mt-5">
                  <div class="form-group mb-1">
                      <h5 class="mb-2">Upload Images/Videos&nbsp;<span v-if="processing"><b-spinner class="small mb-1" small label="Small Spinner"></b-spinner></span></h5>
                      <b-input-group>
                        <b-form-file
                            multiple
                            v-model="mediasForUpload.files"
                            :state="Boolean(mediasForUpload.files.length)"
                            placeholder="Choose images/videos or drop them here..."
                            drop-placeholder="Drop image(s)/video(s) here..."
                            :accept="acceptedFileExtensionsWithDot"
                            class="multi-file"
                          ></b-form-file>
                      </b-input-group>
                  </div>
                  <div class="d-flex justify-content-end">
                    <b-button variant="primary" type="button" :disabled="!readyForUpload(invalid)" @click="uploadMediasForEvent()">Upload</b-button>
                  </div>
                </b-form>
                </ValidationObserver>
                <label class="mt-3 mb-1"><strong>Images</strong></label>
                <b-list-group class="card bg-light rounded p-1 img-list">
                  <b-list-group-item v-for="image in imagesForEvent" v-bind:key="image.id" class="d-flex align-items-center">
                    <FileThumbnail :thumbnail-url="image.thumbnailMicroPublicUrl || image.thumbnailPublicUrl" :full-url="image.publicUrl" file-type="image" size="micro" style="width:50px;height:50px;object-fit:cover;" />
                    <div class="text-dark">
                      <a class="pl-3 text-dark">{{ image.name }}</a>
                    </div>
                  </b-list-group-item>
                </b-list-group>
                <label class="mt-3 mb-1"><strong>Videos</strong></label>
                <b-list-group class="card bg-light rounded p-1 img-list">
                  <b-list-group-item v-for="video in videosForEvent" v-bind:key="video.id" class="d-flex align-items-center">
                    <FileThumbnail size="micro" file-type="video" :thumbnail-url="video.thumbnailPublicUrl" :full-url="video.publicUrl" :processing-status="video.videoProcessingStatus" style="width:50px;height:50px;" />
                    <div class="text-dark">
                      <a class="pl-3 text-dark">{{ video.name }}</a>
                    </div>
                  </b-list-group-item>
                </b-list-group>                
              </div>
            </div>
          </tab-content>

          <!--Finalize-->
          <tab-content class="flexy-item" title="Finalize" icon="icon check">
            <div class="animated bounceInDown">
              <i class="fas fa-check"></i>
            </div>
            <router-link class="complete-button" to="/">Done</router-link>
          </tab-content>

          <!--Footer-->
          <template slot="footer" slot-scope="props">
            <div class="wizard-footer-left">
              <wizard-button  v-if="props.activeTabIndex > 0 && !props.isLastStep" @click.native="handlePrev(props)" class="wizard-footer-left" :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> <span>Previous</span></wizard-button>
            </div>
            <div class="d-flex justify-content-center" v-if="!props.isLastStep">
            </div>
            <div class="wizard-footer-right">
              <wizard-button v-if="!props.isLastStep" @click.native="handleNext(props)" ref="nextBtn" class="wizard-footer-right" :style="props.fillButtonStyle"><span>Next&nbsp;</span><i class="fas fa-arrow-right"></i></wizard-button>
              <wizard-button green v-else @click.native="saveEventLocal()" class="finish-button" :style="props.fillButtonStyle">Complete <i class="fas fa-check"></i></wizard-button>
            </div>
        </template>
        </form-wizard>
    </div>

     <b-modal size="lg" v-model="showInProgressSelector" title="Events in Progress" no-close-on-backdrop no-close-on-esc hide-header-close>
      <div class="text-center pb-5 pt-3">
        <h5>Event(s) already exist for this location.</h5>
        <p>Would you like to <strong>resume</strong> an existing event or <strong>continue</strong> with a new one? </p>
      </div>
      <div class="pb-5">
        <b-table-simple bordered class="mb-5 rg-table">
          <b-thead>
              <b-tr>
                  <b-th>Reported By</b-th>
                  <b-th>Type</b-th>
                  <b-th>Category</b-th>
                  <b-th text-align="center" style="width: 150px;">Action</b-th>
              </b-tr>
          </b-thead>
          <b-tbody>
            <b-tr v-for="event in inProgressEventsForProperty" v-bind:key="event.id" >
              <b-td>
                <div>{{ event.reportedByName }}</div>
                <small class="text-muted">{{ event.dateReportedLocal | formatDate}}</small>
              </b-td>
              <b-td>
                {{ event.typeName }}
              </b-td>
              <b-td>
                {{ event.categoryName }}
              </b-td>
              <b-td data-label="Actions" text-align="center" class="table-action text-center">
                <b-btn variant="link" @click="doResumeEvent(event.id)">
                  <i class="fas fa-play-circle"></i> <span class="d-md-inline d-none">Resume Event</span>
                </b-btn>
              </b-td>
            </b-tr>
          </b-tbody>
        </b-table-simple>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100">
          <b-button variant="success" class="float-right" @click="showInProgressSelector=false">Continue New Event <i class="fas fa-arrow-right"></i></b-button>
        </div>
      </template>
      </b-modal>
  </div>
</template>

<script>
import {FormWizard, TabContent, WizardButton} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {Datetime} from 'vue-datetime'
// You need a specific loader for CSS files
import 'vue-datetime/dist/vue-datetime.css'
import { mapActions } from 'vuex'
import { spr2Procedures } from '../mixins/Spr2SharedFunctions'
import FileThumbnail from '@/components/FileThumbnail.vue'
// component code
export default {
  mixins: [ spr2Procedures ],
  name: 'Events',
  components: {
    FormWizard,
    TabContent,
    WizardButton,
    datetime: Datetime,
    FileThumbnail
  },
  created () {
    this.loadEventTypes()
    const isSopResume = this.$route.query.resumeSop === 'true'
    if (this.eventForEdit && !isSopResume) {
      // Only clear location for a fresh event — preserve it when resuming an SOP
      this.eventForEdit.location = ''
    }
    this.initMediasForUpload()
    this.getLoggedInUserProperties()
      .then((result) => {
        console.log('setting event user  properties: ' + JSON.stringify(result.data.properties, null, 2))
        this.properties = result.data.properties
      })
    this.getAcceptedFileTypes().then((types) => {
      this.acceptedImageTypes = types.filter((item) => { return item.type === 2 })
      this.acceptedVideoTypes = types.filter((item) => { return item.type === 3 })
    })
    if (isSopResume && this.eventForEdit && this.eventForEdit.procedure) {
      this.isResume = true
      if (this.eventForEdit.answeredQuestionTrail && this.eventForEdit.answeredQuestionTrail.length > 0) {
        this.questionIdTrail = this.eventForEdit.answeredQuestionTrail
        this.questionIndexTrailCurrentIndex = this.questionIdTrail.length - 1
        this.currentQuestion = this.questions.find(o => o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex])
      } else {
        this.questionIndexTrailCurrentIndex = 0
        this.currentQuestion = this.questions[0]
      }
    }
  },
  mounted () {
    // SOP-resume tab navigation is handled by the sopResumeReady watcher below,
    // because the wizard is inside a v-if="properties && eventTypes" block and
    // those are populated asynchronously — $refs.wizard is null until both resolve.
  },
  watch: {
    sopResumeReady (isReady) {
      if (isReady) {
        this.$nextTick(() => {
          if (this.$refs.wizard) {
            this.$refs.wizard.changeTab(0, 3)
          }
        })
      }
    }
  },
  data () {
    return {
      currentEvent: {
        property: {},
        type: {},
        category: {},
        dateTime: null,
        eventSeverityLevel: 0,
        location: ''
      },
      currentQuestionImagesStore: [],
      currentQuestionVideosStore: [],
      isResume: false,
      showInProgressSelector: false,
      propertyContacts: null,
      propertyVendors: null,
      mediasForUpload: { type: 'image', files: [] },
      images: [],
      videosForUpload: { type: 'video', files: [] },
      videos: [],
      properties: null,
      currentQuestionStore: {answered: false, answer: false},
      questionIdTrail: [],
      questionIndexTrailCurrentIndex: 0,
      eventErrorsStore: {
        propertyRequiredInError: false,
        dateTimeRequiredInError: false,
        typeRequiredInError: false,
        categoryRequiredInError: false,
        procedureStepInError: false,
        emergencyServicesInvolvedInError: false
      },
      inProgressEventsForProperty: [],
      processing: false,
      acceptedImageTypes: [],
      acceptedVideoTypes: []
    }
  },
  computed: {
    currentQuestion: {
      get: function () {
        return this.currentQuestionStore
      },
      set: function (val) {
        this.currentQuestionStore = val
        console.log('***Setting Current Question:' + JSON.stringify(val, null, 2))
        if (this.currentQuestionStore.typeId !== null && this.spr2_lookupTypeId(this.currentQuestionStore.typeId) === 'ImageUpload') {
          this.doLoadImagesForQuestion(this.currentQuestionStore.id)
          this.doLoadVideosForQuestion(this.currentQuestionStore.id)
        }
        console.log('Current Question type:' + this.currentQuestionStore.typeId)
      }
    },
    currentQuestionImages: {
      get: function () {
        return this.currentQuestionImagesStore
      },
      set: function (val) {
        this.currentQuestionImagesStore = val
      }
    },
    currentQuestionVideos: {
      get: function () {
        return this.currentQuestionVideosStore
      },
      set: function (val) {
        this.currentQuestionVideosStore = val
      }
    },
    currentAnswer: {
      get: function () {
        return this.currentQuestion.answer
      },
      set: function (val) {
        this.currentQuestion.answer = val
        this.currentQuestion.answered = true
      }
    },
    errorsJson () {
      return JSON.stringify(this.eventErrors, null, 2)
    },
    eventErrors () {
      return this.eventErrorsStore
    },
    emergencyServicesInvolved: {
      get: function () {
        return this.eventForEdit.emergencyServicesInvolved
      },
      set: function (val) {
        this.eventForEdit.emergencyServicesInvolved = val
        this.eventForEdit.emergencyServicesInvolvedAnswered = true
      }
    },
    questions () {
      return this.eventForEdit.procedure.questions
    },
    eventForEdit () {
      return this.$store.state.events.eventForEdit
    },
    imagesForEvent () {
      return this.$store.state.events.imagesForEvent
    },
    videosForEvent () {
      return this.$store.state.events.videosForEvent
    },
    nextQuestion2 () {
      var nextQuestionReturn = null
      var nextQuestionId = null
      if (this.currentQuestion.yesResult &&
      (this.spr2_lookupTypeId(this.currentQuestion.typeId) === 'TextInput' || this.spr2_lookupTypeId(this.currentQuestion.typeId) === 'Checklist' ||
      this.spr2_lookupTypeId(this.currentQuestion.typeId) === 'ImageUpload') &&
      this.currentQuestion.yesResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else if (this.currentQuestion.yesResult && this.currentQuestion.answer === true && this.currentQuestion.yesResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.yesResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else if (this.currentQuestion.noResult && this.currentQuestion.answer === false && this.currentQuestion.noResult.type === 'goto') {
        nextQuestionId = this.currentQuestion.noResult.value
        nextQuestionReturn = this.questions.find(o => o.id === nextQuestionId)
      } else {
        nextQuestionReturn = null
      }
      //   if (nextQuestionReturn != null && this.spr2_lookupTypeId(nextQuestionReturn.typeId) === 'ImageUpload') {
      //     this.doLoadImagesForQuestion(nextQuestionReturn.id)
      //   }
      return nextQuestionReturn
    },
    eventTypes () {
      return this.$store.state.events.eventTypes
    },
    selectedDateTime: {
      get: function () {
        return this.eventForEdit.dateOccurredUtc
      },
      set: function (val) {
        console.log('setter on selectedDateTime' + val)
        this.eventForEdit.dateOccurredUtc = val
        if (this.eventForEdit.dateOccurredUtc) {
          this.eventForEdit.dateOccurredUtc = val
          console.log('setting this.errors.dateTimeRequiredInError')
          this.eventErrors.dateTimeRequiredInError = false
          console.log('Errors:' + JSON.stringify(this.eventErrors, null, 2))
        }
      }
    },
    selectedPropertyId: {
      get: function () {
        return this.currentEvent.property.id
      },
      set: function (val) {
        var property = this.properties.find(o => o.id === val)
        this.currentEvent.property = property
        if (property) {
          this.eventErrors.propertyRequiredInError = false
          this.eventForEdit.property = property
        }
        this.checkPropertyEventsInProgress()
      }
    },
    selectedTypeId: {
      get: function () {
        return this.currentEvent.type.id
      },
      set: function (val) {
        var type = this.$store.state.events.eventTypes.find(o => o.id === val)
        this.currentEvent.type = type
        if (this.currentEvent.type) {
          this.eventErrors.typeRequiredInError = false
          this.eventForEdit.type = type
        }
        this.currentEvent.category = null
      }
    },
    selectedCategoryId: {
      get: function () {
        if (this.currentEvent.category) {
          return this.currentEvent.category.id
        } else {
          return null
        }
      },
      set: function (val) {
        var category = this.currentEvent.type.categories.find(o => o.id === val)
        this.currentEvent.category = category
        if (this.currentEvent.category) {
          this.eventErrors.categoryRequiredInError = false
          this.eventForEdit.category = category
        }
      }
    },
    selectedEventSeverity: {
      get: function () {
        return this.currentEvent.eventSeverityLevel
      },
      set: function (val) {
        this.currentEvent.eventSeverityLevel = val
        this.eventForEdit.eventSeverityLevel = val
      }
    },
    propertyOptions () {
      var properties = this.properties
      var results = []
      results = properties.map((p) => { return { text: p.name, value: p.id } })
      console.log('Returning Property Options: ' + JSON.stringify(results, null, 2))
      return results
    },
    eventCategoryOptions () {
      console.log('getting category options.')
      var type = this.$store.state.events.eventTypes.find(o => o.id === this.currentEvent.type.id)
      if (type === undefined) {
        return []
      }
      var categories = type.categories
      var results = []
      results = categories.map((p) => { return { text: p.name, value: p.id } })
      console.log('Returning Event Category Options: ' + JSON.stringify(results, null, 2))
      return results
    },
    eventTypeOptions () {
      var types = this.eventTypes
      var results = []
      results = types.map((p) => { return { text: p.name, value: p.id } })
      return results
    },
    acceptedImageExtensionsWithDot () {
      return this.acceptedImageTypes.map(a => `.${a.ext}`).join(',')
    },
    acceptedVideoExtensionsWithDot () {
      return this.acceptedVideoTypes.map(a => `.${a.ext}`).join(',')
    },
    acceptedFileExtensionsWithDot () {
      let videoExt = this.acceptedVideoTypes.map(a => `.${a.ext}`)
      let imageExt = this.acceptedImageTypes.map(a => `.${a.ext}`)
      return videoExt.concat(imageExt).join(',')
    },
    sopResumeReady () {
      // The wizard sits inside v-if="properties && eventTypes". eventTypes starts as []
      // (truthy), so the real gate is properties becoming non-null. Once that resolves,
      // $refs.wizard is available and we can call changeTab.
      return this.$route.query.resumeSop === 'true' &&
        this.isResume &&
        !!this.properties &&
        !!(this.eventForEdit && this.eventForEdit.procedure)
    }
  },
  methods: {
    ...mapActions('events', ['loadEventTypes', 'createNewEventWithReturn', 'saveEvent', 'saveEventProgress', 'uploadMedias', 'uploadMediasForQuestion','loadEventImages', 'loadEventVideos', 'getPropertyContacts', 'getPropertyVendors', 'getLoggedInUserProperties', 'getPropertyEventsInProgress', 'resumeEvent', 'getEventQuestionImages', 'getEventQuestionVideos']),
    ...mapActions('resources', ['getAcceptedFileTypes']),
    async createNewEventWithSelections () {
      console.log('Calling Create New Event.')
      var newEventRequest = {
        typeId: this.selectedTypeId,
        categoryId: this.selectedCategoryId,
        propertyId: this.selectedPropertyId,
        location: this.eventForEdit.location
      }

      const response = await this.createNewEventWithReturn(newEventRequest)

      console.log('Full response from get new event: ' + JSON.stringify(response, null, 2))
      this.eventForEdit.emergencyServicesInvolvedAnswered = false
      if (!response.data.success) {
        alert('Did not match a procedure, please re-select type and category, or go fix your procedures.')
        return false
      }
      return true
    },
    async checkPropertyEventsInProgress () {
      var propertyEventsInProgressResult = await this.getPropertyEventsInProgress(this.selectedPropertyId)
      var propertyEventsInProgress = propertyEventsInProgressResult.data
      console.log('propertyEventsInProgress: ' + JSON.stringify(propertyEventsInProgress, null, 2))
      if (propertyEventsInProgress.eventsInProgress.length > 0) {
        this.inProgressEventsForProperty = propertyEventsInProgress.eventsInProgress
        this.showInProgressSelector = true
      }
    },
    async doResumeEvent (eventId) {
      await this.resumeEvent(eventId)
      // console.log('Resuming Event: ' + JSON.stringify(this.eventForEdit, null, 2))
      this.isResume = true
      // Fast forward to the question at hand, or set everything to 0 if nothing has been answered
      if (this.eventForEdit.answeredQuestionTrail && this.eventForEdit.answeredQuestionTrail.length > 0) {
        this.questionIdTrail = this.eventForEdit.answeredQuestionTrail
        this.questionIndexTrailCurrentIndex = this.questionIdTrail.length - 1
        this.currentQuestion = this.questions.find(o => o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex])
      } else {
        this.questionIndexTrailCurrentIndex = 0
        this.currentQuestion = this.questions[0]
      }
      this.goNext()
      this.showInProgressSelector = false
    },
    readyForUpload (isFormInvalid) {
      console.log('Checking Ready for upload. Is invalid: ' + isFormInvalid + ', image: ' + JSON.stringify(this.mediasForUpload, null, 2))
      if (isFormInvalid === false && this.processing === false) {
        if (this.mediasForUpload.files.length < 1) {
          return false
        } else {
          return true
        }
      } else {
        return false
      }
    },
    loadContacts () {
      this.getPropertyContacts(this.currentEvent.property.id).then(result => { this.propertyContacts = result.data.people })
    },
    loadPropertyVendors () {
      this.getPropertyVendors(this.currentEvent.property.id).then(result => { this.propertyVendors = result.data.vendors })
    },
    dumpEvent () {
      console.log('Full event for edit: ' + JSON.stringify(this.eventForEdit, null, 2))
    },
    goNext () {
      setTimeout(() => this.$refs.nextBtn.$el.click(), 200)
    },
    saveEventLocal () {
      // console.log('Save this guy: ' + JSON.stringify(this.eventForEdit, null, 2))
      this.saveEventProgress({eventProgress: this.eventForEdit, convertNumberIfNeeded: false})
    },
    saveEventLocalSetSopInProgress () {
      // change to "SOP In Progres"
      this.eventForEdit.status = 5
      this.eventForEdit.isSopComplete = false
      console.log('Save this guy: ' + JSON.stringify(this.eventForEdit, null, 2))
      this.saveEventProgress({eventProgress: this.eventForEdit, convertNumberIfNeeded: true})
    },
    saveEventLocalSetSopComplete () {
      // change to "New"
      this.eventForEdit.status = 0
      this.eventForEdit.isSopComplete = true
      console.log('Save this guy: ' + JSON.stringify(this.eventForEdit, null, 2))
      this.saveEventProgress({eventProgress: this.eventForEdit, convertNumberIfNeeded: false})
    },
    validateEmergencyServices () {
      if (!this.eventForEdit.emergencyServicesInvolvedAnswered) {
        this.eventErrors.emergencyServicesInvolvedInError = true
        return false
      } else {
        this.eventErrors.emergencyServicesInvolvedInError = false
        return true
      }
    },
    validateFirstTab () {
      if (this.isResume) {
        console.log('validateFirstTab: (resume) returning valid.')
        return true
      }
      return this.validateLocationTime().then(() => this.validateTypeCategory())
    },
    validateLocationTime () {
      return new Promise((resolve, reject) => {
        var valid = true
        if (this.selectedPropertyId) {
          this.eventErrors.propertyRequiredInError = false
        } else {
          this.eventErrors.propertyRequiredInError = true
          valid = false
        }
        if (this.selectedTypeId) {
          this.eventErrors.typeRequiredInError = false
        } else {
          this.eventErrors.typeRequiredInError = true
          valid = false
        }
        if (this.selectedCategoryId) {
          this.eventErrors.categoryRequiredInError = false
        } else {
          this.eventErrors.categoryRequiredInError = true
          valid = false
        }

        if (valid) {
          console.log('returning valid.')
          resolve(true)
        } else {
          console.log('validateLocationTime: return invalid')
          reject(new Error('validation problems'))
        }
      })
    },
    async validateTypeCategory () {
      // Load the new event.
      const result = await this.createNewEventWithSelections()
      if (result) {
        console.log('got result from create')
        console.log('Questions[0]: ' + JSON.stringify(this.questions[0], null, 2))
        this.questionIdTrail = []
        this.questionIndexTrailCurrentIndex = 0
        this.currentQuestion = this.questions[0]
        this.questionIdTrail.push(this.currentQuestion.id)
      }
      return result
    },
    validateSeverityAndDateStep () {
      return new Promise((resolve, reject) => {
        var valid = true
        if (this.selectedDateTime) {
          this.eventErrors.dateTimeRequiredInError = false
        } else {
          this.eventErrors.dateTimeRequiredInError = true
          valid = false
        }
        if (valid) {
          console.log('returning valid.')
          this.saveEventLocalSetSopInProgress()
          resolve(true)
        } else {
          console.log('return invalid')
          reject(new Error('validation problems'))
        }
      })
    },
    beforeTabChange () {
      return true
    },
    handlePrev (props) {
      if (props.activeTabIndex === 3 && this.questionIndexTrailCurrentIndex > 0) {
        this.eventErrors.procedureStepInError = false
        this.$delete(this.questionIdTrail, this.questionIndexTrailCurrentIndex)
        this.questionIndexTrailCurrentIndex--
        this.currentQuestion = this.questions.find(o => o.id === this.questionIdTrail[this.questionIndexTrailCurrentIndex])
        this.eventForEdit.answeredQuestionTrail = this.questionIdTrail
        console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
        console.log('QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex)
      } else {
        props.prevTab()
      }
    },
    validateCurrentQuestion () {
      console.log(`type ${this.currentQuestion.typeId}`)
      if (this.currentQuestion.typeDescriptor === 'Acknowledgement') {
        console.log(this.errorsJson)
        if (this.currentQuestion.answer !== true) {
          this.eventErrors.procedureStepInError = true
          this.eventErrors.procedureStepInErrorText = 'This must be acknowledged.'
          return false
        } else {
          this.eventErrors.procedureStepInError = false
          this.eventErrors.procedureStepInErrorText = ''
        }
      }
      if (this.currentQuestion.typeDescriptor === 'YesOrNo') {
        console.log(this.errorsJson)
        if (this.currentQuestion.answered !== true) {
          this.eventErrors.procedureStepInError = true
          this.eventErrors.procedureStepInErrorText = 'You must choose yes or no.'
          return false
        } else {
          this.eventErrors.procedureStepInError = false
          this.eventErrors.procedureStepInErrorText = ''
        }
      }
      console.log('returning true from validation')
      return true
    },
    handleNext (props) {
      console.log('Props: ' + JSON.stringify(props, null, 2))
      console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
      console.log('QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex)
      // This is a resume event probably and we need to fast forward past the emergency services part.
      if (props.activeTabIndex === 0 && this.eventForEdit.emergencyServicesInvolvedAnswered === true) {
        props.nextTab()
        props.nextTab()
        props.nextTab()
        return
      }
      if (props.activeTabIndex === 1) {
        if (!this.validateEmergencyServices()) {
          this.saveEventLocal()
          return
        }
      } else if (props.activeTabIndex === 3 && !this.validateCurrentQuestion()) {
        return
      } else if (props.activeTabIndex === 3 && this.nextQuestion2) {
        this.currentQuestion = this.nextQuestion2
        var found = this.questionIdTrail.find(id => id === this.currentQuestion.id)
        if (!found) {
          console.log(`pushing ${this.currentQuestion.id} to questionIdTrail`)
          this.questionIdTrail.push(this.currentQuestion.id)
          this.questionIndexTrailCurrentIndex++
        }

        console.log('QuestionId Trail: ' + JSON.stringify(this.questionIdTrail, null, 2))
        console.log('QuestionIndexTrailCurrentIndex' + this.questionIndexTrailCurrentIndex)
        this.saveEventLocal()
        return
      }
      // Images and Videos tabs
      if (props.activeTabIndex === 4 || props.activeTabIndex === 5) {
        console.log('Setting complete.....')
        this.saveEventLocalSetSopComplete()
        this.loadImages(this.eventForEdit.id)
        this.loadVideos(this.eventForEdit.id)
      }
      this.eventForEdit.answeredQuestionTrail = this.questionIdTrail
      console.log('calling props.nextTab()')
      // Call saveEventLocal between all the tabs, except EMS, Images and Videos, those are handled elsewhere
      if (props.activeTabIndex > 0 && props.activeTabIndex !== 4 && props.activeTabIndex !== 5 && props.activeTabIndex !== 2) {
        this.saveEventLocal()
      }
      
      props.nextTab()
    },
    // Images
    initMediasForUpload () {
      this.mediasForUpload = { files: [] }
    },
    loadImages (eventId) {
      return this.loadEventImages(eventId)
        .then(() => this.setImagesForEvent())
    },
    setImagesForEvent () {
      this.eventForEdit.images = this.imagesForEvent
    },
    uploadMediasForEvent () {
      this.mediasForUpload.eventId = this.eventForEdit.id
      this.processing = true

      this.uploadMedias(this.mediasForUpload)
      .then(() => this.loadImages(this.eventForEdit.id))
      .then(() => this.loadVideos(this.eventForEdit.id))
      .then(() => this.initMediasForUpload())
        .then(() => { 
          this.processing = false
         })
    },
    uploadMediasForEventQuestion (questionId) {
      this.mediasForUpload.eventId = this.eventForEdit.id
      this.mediasForUpload.questionId = questionId
      this.processing = true
      this.uploadMediasForQuestion(this.mediasForUpload)
        .then((result) => {
          this.mergeImagesIntoQuestion(result.data.images)
          this.mergeVideosIntoQuestion(result.data.videos)
        })
        .then(() => this.doLoadImagesForQuestion(questionId))
        .then(() => this.doLoadVideosForQuestion(questionId))
        .then(() => this.initMediasForUpload())
        .then(() => { 
          this.processing = false
          this.$toasted.success('Media upload successfully', {duration: 4000})
        })
    },
    async doLoadImagesForQuestion (questionId) {
      var response = (await this.getEventQuestionImages({eventId: this.eventForEdit.id, questionId: questionId})).data
      this.currentQuestionImagesStore = response.images
    },
    mergeImagesIntoQuestion (newImagesArray) {
      console.log('current Question images before: ' + JSON.stringify(this.currentQuestion.images, null, 2))
      this.currentQuestion.images = (this.currentQuestion.images || []).concat(newImagesArray || [])
      console.log('current Question images is now: ' + JSON.stringify(this.currentQuestion.images, null, 2))
    },
    // Videos
    loadVideos (eventId) {
      return this.loadEventVideos(eventId)
        .then(() => this.setVideosForEvent())
    },
    setVideosForEvent () {
      this.eventForEdit.videos = this.videosForEvent
    },
    async doLoadVideosForQuestion (questionId) {
      var response = (await this.getEventQuestionVideos({eventId: this.eventForEdit.id, questionId: questionId})).data
      this.currentQuestionVideosStore = response.videos
    },
    mergeVideosIntoQuestion (newVideosArray) {
      console.log('current Question videos before: ' + JSON.stringify(this.currentQuestion.videos, null, 2))
      this.currentQuestion.videos = (this.currentQuestion.videos || []).concat(newVideosArray || [])
      console.log('current Question videos is now: ' + JSON.stringify(this.currentQuestion.videos, null, 2))
    }
  }
}
</script>

<style>
/*Toggle Buttons*/
.ui.button.basic.red.active {
  background-color: #db2828 !important;
  color: #ffffff !important;
}
.ui.button.basic.green.active {
  background-color: #21ba45!important;
  color: #ffffff !important;
}
.ui.button.basic:hover{
  background-color: #efefef !important;
}
.ui.buttons .button {
  border-right: 1px solid rgba(0,0,0,0.1);
}
.ui.buttons .button:last-child {
  border: none;
}
.ui.buttons .button.active {
  background-color: rgb(32, 160, 255);
  color: #fff;
}

.flexy-item {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #88e95d;
}

.side-panel {
  position: fixed !important;
  top: 50px;
  height: calc(100% - 71px) !important;
  min-height: 0 !important;
  background: #fff;
  width: 300px;
  -webkit-animation: slide 0.25s forwards;
  -webkit-animation-delay: .2s;
  animation: slide 0.25s forwards;
  animation-delay: .2s;
  box-shadow: -3px 0 10px rgba(0,0,0,0.2);
}

.right {
  right: -300px;
}

.side-panel.collapsing {
  transition: none;
  transform: none;
}

@-webkit-keyframes slide {
  100% {
    right: 0;
  }
}

@keyframes slide {
  100% {
    right: 0;
  }
}

@media screen and (max-width: 767px){
  .side-panel {
    width: 75%;
  }
}

/*Wizard*/
@media screen and (min-width: 768px) {
  .event-container {
    height: calc(100vh - 50px);
    background-color: #13385a !important;
    background-position: 0 0;
    background-size: 300%;
  }
}

.vue-form-wizard {
  display: block;
  margin: 0 auto 0 auto;
  padding: 0;
  position: relative;
  min-height: 5em;
  height: calc(100vh - 180px) !important;
  border-radius: .4em;
  background-color: #fff;
  overflow: hidden;
  box-shadow: 0 1.7em 5.5em -0.94em rgba(0, 0, 0, 0.3), 0 2em 3em 0.5em rgba(0, 0, 0, 0.1), 0 1.8em 2em -1.5em rgba(0, 0, 0, 0.2);
  will-change: background, box-shadow;
  transition: all 0.3s ease-out;
}

.vue-form-wizard .wizard-header {
  display: none !important;
}
.vue-form-wizard .complete-button {
  position: absolute;
  bottom: -51px;
  padding: 13px 0;
  width: 100%;
  background: #f5f5f5;
  z-index: 10;
  text-align: center;
  font-size: 125%;
  font-weight: 500;
}

.vue-form-wizard .complete-button:hover {
  background: #efefef;
  text-decoration: none;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .complete-button {
    padding: 36px 0;
    bottom: -23px;
  }
}

/*Wizard Steps*/
.vue-form-wizard .wizard-icon-circle .wizard-icon-container,
.vue-form-wizard .wizard-icon-circle{
  align-items: center !important;
  border-radius: 50% !important;
  height: 100%;
  width: 50px !important;
  height: 50px !important;
  display: none !important;
}

.vue-form-wizard .wizard-icon-circle .wizard-icon{
  font-size: 0.8em !important;
    margin: 0;
}

.vue-form-wizard .wizard-icon-circle.checked .wizard-icon{
  color: rgb(32, 160, 255);
}

.vue-form-wizard .wizard-nav-pills{
  background: #f7f7f7;
  padding: 1.4em 1em 1em 1em;
}

.vue-form-wizard .wizard-nav-pills > li > a {
  top: 0;
}

.vue-form-wizard .wizard-nav-pills li:last-child{
  display: none;
}

.vue-form-wizard .wizard-nav-pills .stepTitle{
  color: rgba(0,0,0,0.5);
}

.vue-form-wizard .wizard-nav-pills .active .stepTitle{
  font-weight: 500;
}

.vue-form-wizard .wizard-navigation {
    height: calc(100% - 51px);
    position: absolute;
    width: 100%;
    display: flex;
    flex-direction: column;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .wizard-navigation,
  .vue-form-wizard .wizard-navigation .wizard-tab-container .card {
    background-color: #0b2b48;
    color: #fff;
  }
}

.vue-form-wizard.md .wizard-navigation .wizard-progress-with-circle{
    top: 0 !important;
    left: 0;
    position: absolute !important;
    z-index: 100;
    width: 100%;
    background: rgba(0,0,0,0.15);
    height: 8px !important;
}

/*Footer*/
.vue-form-wizard .wizard-card-footer {
  background: #f5f5f5;
  position: absolute;
  bottom: 0;
  width: 100%;
  padding: 0;
  display: flex;
}

.vue-form-wizard .wizard-card-footer button{
  padding-top: 1em;
  padding-bottom: 1em;
  border-radius: 0;
}

.vue-form-wizard .wizard-card-footer button:hover {
  opacity: 0.9;
}

.vue-form-wizard .wizard-card-footer > div{
  display: flex;
  flex-grow: 1;
  padding: 0 !important;
}

.vue-form-wizard .wizard-card-footer .wizard-footer-right{
  justify-content: flex-end !important;
}

.vue-form-wizard .wizard-card-footer .wizard-footer-left{
  justify-content: flex-start !important;
}

/*Tab Container*/
.vue-form-wizard .wizard-tab-content{
  padding-top: 0;
  overflow: auto;
  height: 100%;
}

.vue-form-wizard .wizard-tab-content .btn-lg{
  border-radius: 15px !important;
  padding: 0 30px !important;
  margin: 0 5px 0 0;
  min-width: 85px;
  height: 85px;
}

@media screen and (max-width: 767px) {
  .vue-form-wizard .wizard-tab-content .btn-lg{
    padding: 0 35px !important;
    min-width: 100px;
    height: 100px;
    border-width: 2px;
    font-weight: 600;
  }
}

.vue-form-wizard .wizard-tab-content .wizard-tab-container:first-child{
  padding-top: 0;
}

.vue-form-wizard .wizard-tab-container > h4{
  background-image: linear-gradient(-120deg, #26e289 0%, #1a5fa2 100%, #ff0000 200%);
  background-position: 0 0;
  background-size: 300%;
  padding: 2em 0;
  margin: 0 -2em;
  color: #fff;
  display: none;
}

.vue-form-wizard .wizard-tab-container.flexy-item{
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-image: linear-gradient(-120deg, #26e289 0%, #1a5fa2 100%, #ff0000 200%);
  background-position: 0 0;
  background-size: 300%;
}

.vue-form-wizard .wizard-tab-container.flexy-item i{
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 200%;
}

.vue-form-wizard .wizard-tab-container > .ui {
  padding-top: 2em;;
}

.vue-form-wizard .wizard-tab-container > .ui.card {
  padding: initial;
}

.vue-form-wizard .wizard-card-footer .wizard-tab-container[style*=""] {
  transition: all .5s ease-in-out;
  opacity: 1;
}

.vue-form-wizard .wizard-card-footer .wizard-tab-container[style*="display: none;"] {
  transition: none;
  opacity: 0;
}

.vue-form-wizard .wizard-progress-bar{
  background-color: #4db53e !important;
  position: relative;
  z-index: 2000;
}

.vue-form-wizard .wizard-progress-bar:before{
  content: "";
  display: block;
  position: absolute;
  right: -5px;
  top: -5px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  z-index: 200;
}
.vue-form-wizard .vdatetime input {
  display: block;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  -webkit-transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-box-shadow 0.15s ease-in-out;
  height: calc(1.5em + 1rem + 2px);
  width: 100%;
  padding: 0.5rem 1rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.3rem;
}

.list-group-item.checkbox-list {
  box-shadow: 0 1px 6px rgba(0,0,0,0.1);
  padding: 0;
  color: #000 !important;
  background: #fff;
}

.list-group-item.checkbox-list .custom-control-label{
  padding: 1.25em 1em 1.25em 3.7em !important;
  width: 100%;
}

.list-group-item.checkbox-list:hover {
  background:#efefef;
}

.list-group-item.custom-checkbox .custom-control-label::before {
    left: .85em;
    top: .85em;
    border-radius: 50% !important;
    height: 30px;
    width: 30px;
}

.list-group-item .custom-control-input:checked ~ .custom-control-label::before {
  background-color: #4db53e;
  border-color: #4db53e;
}

.list-group-item.custom-checkbox .custom-control-label::after {
    left: 1.2rem;
    top: 1.2rem;
    width: 1.5em;
    height: 1.5em;
}

.img-list:empty:after {
  content: "No images have been uploaded";
  display: block;
  text-align: center;
  color: #999;
  padding: 15px 0;
}

.video-list:empty:after {
  content: "No videos have been uploaded";
  display: block;
  text-align: center;
  color: #999;
  padding: 15px 0;
}

/*Mobile*/
@media (max-width: 767px) {
  .event-container {
    background-color: #13385a !important;
  }
  .vue-form-wizard {
    display: block;
    width: 100%;
    height: calc(100% - 110px) !important;
    margin: 0;
    padding: 0;
    box-shadow: none;
    position: fixed;
    background: #0b2b48 !important;
    top: 110px;
    left: 0;
    right: 0;
    bottom: 0;
    border-radius: 0;
    z-index: 900;
  }

  .vue-form-wizard .stepTitle {
    display: none;
  }

  .vue-form-wizard .wizard-tab-content {
    padding: 0 30px 0 30px !important;
    height: calc(100% - 75px);
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container{
    height: 100% ;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  .vue-form-wizard .wizard-navigation {
    height: calc(100% - 45px);
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container .ui.card{
    flex-grow: 1;
    justify-content: center;
    box-shadow: none;
  }

  .vue-form-wizard .wizard-tab-content .wizard-tab-container .ui.card > div{
    flex-grow: 0;
  }

  h2 {
    display: none;
  }

  .vue-form-wizard .wizard-card-footer {
    padding: 0 !important;
    align-items: center;
    flex-direction: row !important;
    flex-wrap: nowrap;
    bottom: 52px;
    background-color: transparent;
  }

  .vue-form-wizard .wizard-card-footer .menu.active{
    position: fixed;
    right: 0 !important;
    bottom: 60px !important;
    border-radius: 0;
  }

  .vue-form-wizard .wizard-card-footer .menu.active:after{
    display: none;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right,
  .vue-form-wizard .wizard-card-footer .wizard-footer-left{
    max-width: none;
    min-width: 50px !important;
    width: 50px !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-left{
    justify-content: flex-end;
    border-radius: 0 30px 30px 0 !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-footer-right{
    justify-content: flex-start;
    border-radius: 30px 0 0 30px !important;
  }

  .vue-form-wizard .wizard-card-footer .wizard-btn.finish-button{
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    height: 60px;
  }
  .vue-form-wizard .wizard-card-footer .wizard-btn {
    padding: 1.5em 1em;
    max-width: 60px !important;
    width: 60px !important;
    height: 60px;
    margin: 0 !important;
  }
  .vue-form-wizard .wizard-card-footer .wizard-btn span {
    display: none;
    min-width: 0px;
  }

  .ui.button.basic.red,
  .ui.button.basic.green {
    padding: 2em 2.5em;
    margin: 0 1em;
  }

  .dropdown.expanded-dropdown,
  .dropdown.expanded-dropdown.active {
    z-index: 0;
    padding: 0 !important;
    border: none !important;
    box-shadow: none !important;
    height: 100% !important;
    min-height: 100% !important;
    max-height: 100% !important;
    transition: none !important;
    transform: none !important;
  }

  .dropdown.expanded-dropdown .text{
    display: none;
  }

  .dropdown.expanded-dropdown .menu {
    position: relative;
    padding: 0 !important;
    height: 100% !important;
    min-height: 100% !important;
    max-height: 100% !important;
    display: flex !important;
    flex-wrap: wrap;
    box-shadow: none !important;
    border: none;
    overflow: visible !important;
    -o-transition-property: none !important;
    -moz-transition-property: none !important;
    -ms-transition-property: none !important;
    -webkit-transition-property: none !important;
    transition-property: none !important;
    -o-transform: none !important;
    -moz-transform: none !important;
    -ms-transform: none !important;
    -webkit-transform: none !important;
    transform: none !important;
    -webkit-animation: none !important;
    -moz-animation: none !important;
    -o-animation: none !important;
    -ms-animation: none !important;
    animation: none !important;
  }

  .dropdown.expanded-dropdown .menu > .item{
    width: 33.333% !important;
    padding: 10px 5px !important;
    border: 1px solid #ccc !important;
    margin-right: -1px;
    margin-top: -1px;
    text-align: center !important;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .dropdown.expanded-dropdown .menu > .item.active{
    color: #fff;
    background-color: rgb(32, 160, 255);
    border-color: rgb(32, 160, 255) !important;
  }

  .vue-form-wizard .wizard-nav-pills{
    display: none !important;
  }

}

/*Animate finish*/
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

@-webkit-keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

@keyframes bounceInDown {
  from,
  60%,
  75%,
  90%,
  to {
    -webkit-animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    animation-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -3000px, 0);
    transform: translate3d(0, -3000px, 0);
  }

  60% {
    opacity: 1;
    -webkit-transform: translate3d(0, 25px, 0);
    transform: translate3d(0, 25px, 0);
  }

  75% {
    -webkit-transform: translate3d(0, -10px, 0);
    transform: translate3d(0, -10px, 0);
  }

  90% {
    -webkit-transform: translate3d(0, 5px, 0);
    transform: translate3d(0, 5px, 0);
  }

  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }
}

.bounceInDown {
  -webkit-animation-name: bounceInDown;
  animation-name: bounceInDown;
  background-color: #88e95d;
  color: #fff;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  text-align: center;
}

.bounceInDown i {
  display: block;
  margin: auto;
  padding-top: 28px;
}

/*Quick Updates - Todo, swap buttons and turn back on focus*/
.btn-outline-danger:not(:disabled):not(.disabled):focus,
.btn-outline-danger:not(:disabled):not(.disabled):not(.active):focus {
  box-shadow: none !important;
  background-color: #fff;
  color: #dc3545;
}
.btn-outline-danger.active,
.btn-outline-danger.active.focus,
.btn-outline-danger.active:focus{
  box-shadow: none !important;
  background-color:#dc3545 !important;
  color: #fff !important;
}
.btn-outline-success:not(:disabled):not(.disabled):focus,
.btn-outline-success:not(:disabled):not(.disabled):not(.active):focus {
  box-shadow: none !important;
  background-color: #fff;
  color: #28a745;
}
.btn-outline-success.active,
.btn-outline-success.active.focus,
.btn-outline-success.active:focus{
  box-shadow: none !important;
  background-color:#28a745 !important;
  color: #fff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/EventAdd.vue